import React, { Suspense } from "react";
import { Redirect, Switch } from "react-router-dom";
import { LayoutSplashScreen, ContentRoute } from "../_metronic/layout";
import { BuilderPage } from "./pages/BuilderPage";
import { MyPage } from "./pages/MyPage";
import { UsersPage } from "./pages/UsersPage";
import AssetsPage from "./pages/AssetsPage";
import HumanResourcesPage from "./pages/HumanResourcesPage";
import PartnersPage from "./pages/PartnersPage";
import CampaignsPage from "./pages/CampaignsPage";
import RequestsPage from "./pages/RequestsPage";
import RequestsMerchantPage from "./pages/RequestsMerchantPage";
import UsageHistoryPage from "./pages/UsageHistoryPage";
import CategoryNamesPage from "./pages/CategoryNamesPage"
import EmployeeListPage from "./pages/EmployeeListPage";
import ExpectedCampaignsPage from "./pages/ExpectedCampaignsPage";
import DashboardPage from "./pages/DashboardPage";
import ReportsPage from "./pages/ReportsPage";
import NotificationsPage from "./pages/NotificationsPage";
import ComplaintsPage from "./pages/ComplaintsPage";
import MerchantPage from "./pages/MerchantPage";

// import HtmlPages from "./pages/HtmlPages";


export default function BasePage() {

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        {
          /* Redirect from root URL to /dashboard. */
          <Redirect exact from="/" to="/users" />
        }
        {/* <ContentRoute path="/dashboard" component={DashboardPage} /> */}
        <ContentRoute path="/builder" component={BuilderPage} />
        <ContentRoute path="/my-page" component={MyPage} />
        <ContentRoute path="/users" component={UsersPage} />
        <ContentRoute path="/assets" component={AssetsPage} />
        <ContentRoute path="/humanresource" component={HumanResourcesPage} />
        <ContentRoute path="/partners" component={PartnersPage} />
        <ContentRoute path="/campaigns" component={CampaignsPage} />
        <ContentRoute path="/categorynames" component={CategoryNamesPage} />
        <ContentRoute path="/requests" component={RequestsPage} />
        <ContentRoute path="/by-merchant" component={RequestsMerchantPage} />
        <ContentRoute path="/expectedcampaigns" component={ExpectedCampaignsPage} />
        <ContentRoute path="/usagehistory" component={UsageHistoryPage} />
        <ContentRoute path="/employeelist" component={EmployeeListPage} />
        <ContentRoute path="/dashboard" component={DashboardPage} />
        <ContentRoute path="/reports" component={ReportsPage} />
        <ContentRoute path="/notifications" component={NotificationsPage} />
        <ContentRoute path="/complaints" component={ComplaintsPage} />
        <ContentRoute path="/merchants" component={MerchantPage} />


        {/* <ContentRoute path="#/privacy" component={HtmlPages} /> */}

        <Redirect to="error/error-v5" />
      </Switch>
    </Suspense>
  );
}
